import React, { useEffect, useState } from "react";
import api from "../../axiosConfig";
import { Table, Container, Row, Col, Form, Alert } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import "../pagination.css";
import { format } from "date-fns";

const IstoricList = () => {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const itemsPerPage = 20;

  useEffect(() => {
    let active = true;
    const fetchItems = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await api.get("/istoric/", {
          params: {
            offset: currentPage * itemsPerPage,
            limit: itemsPerPage,
            search: search,
          },
        });
        if (!active) return;
        setItems(res.data.items || []);
        setTotalCount(res.data.total || 0);
      } catch (error) {
        if (!active) return;
        setItems([]);
        setTotalCount(0);
        setError("Istoricul nu a putut fi încărcat. Reîncarcă pagina pentru a încerca din nou.");
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchItems();
    return () => { active = false; };
  }, [currentPage, search]);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const getActionBadge = (actionType) => {
    if (actionType === "Adăugare") return <span className="badge bg-success">Adăugare</span>;
    if (actionType === "Editare") return <span className="badge bg-warning text-dark">Editare</span>;
    if (actionType === "Ștergere") return <span className="badge bg-danger">Ștergere</span>;
    return <span className="badge bg-secondary">{actionType}</span>;
  };

  const getDocType = (rectype) => {
    if (rectype === 0) return "Intrare furnizor";
    if (rectype === 120) return "Încasare Casă/Bancă";
    if (rectype === 121) return "Plată Casă/Bancă";
    if (rectype === 20) return "Dare în folosință Ob.Inv.";
    if (rectype === 21) return "Transfer Ob.Inv.";
    if (rectype === 22) return "Casare Ob.Inv.";
    return `Tip ${rectype}`;
  };

  return (
    <Container className="mt-4">
      <Row className="mb-3">
        <Col md={8}>
          <h2>Istoric Documente (Audit Log)</h2>
        </Col>
        <Col md={4}>
          <Form.Control
            type="text"
            placeholder="Caută după nr. document..."
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setCurrentPage(0);
            }}
          />
        </Col>
      </Row>

      {error && <Alert variant="danger">{error}</Alert>}
      <Table striped bordered hover size="sm">
        <thead className="table-dark">
          <tr>
            <th>Data & Ora</th>
            <th>Utilizator</th>
            <th>Acțiune</th>
            <th>Modul (Tip Doc)</th>
            <th>Nr. Document</th>
          </tr>
        </thead>
        <tbody>
          {!loading && !error && items.map((item) => (
            <tr key={item.id}>
              <td>{format(new Date(item.action_date), "dd.MM.yyyy HH:mm:ss")}</td>
              <td className="fw-bold">{item.user_nume}</td>
              <td>{getActionBadge(item.action_type_nume)}</td>
              <td>{getDocType(item.bxrectype)}</td>
              <td>{item.bxdoc_no || "-"}</td>
            </tr>
          ))}
          {loading && <tr><td colSpan="5" className="text-center">Se încarcă istoricul...</td></tr>}
          {!loading && !error && items.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center">Nu există înregistrări în istoric.</td>
            </tr>
          )}
        </tbody>
      </Table>
      {!loading && !error && totalCount > itemsPerPage && (
        <ReactPaginate
          previousLabel={"Înapoi"}
          nextLabel={"Înainte"}
          breakLabel={"..."}
          pageCount={Math.ceil(totalCount / itemsPerPage)}
          marginPagesDisplayed={2}
          pageRangeDisplayed={3}
          onPageChange={handlePageClick}
          containerClassName={"pagination justify-content-center"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          activeClassName={"active"}
          forcePage={currentPage}
        />
      )}
    </Container>
  );
};

export default IstoricList;
